/* ================================================== */
/* LIST
/* ================================================== */

$(document).ready(function() {

	// Form
	var $categories = $('#list-categories');
	$('select', $categories).change(function() {
		($(this).val() == '') ? window.location.href = $categories.attr('action') : $categories.submit();
	});

	// Autocomplete
	var $datalist = $('#list-search-list'),
		$input = $('#list-search-input');
	if ($datalist.length && $input.length) {
		$input.on('change select input', function() {
			var options = $datalist[0].options,
				val = $(this).val();

			for (var i=0; i < options.length; i++) {
				if (options[i].value === val) {
					if ($datalist.data('base') !== 'undefined') {
						window.location.href = $datalist.data('base').replace('{value}', $(options[i]).data('value'));
					}
					break;
				}
			}
		});
	}

});